import { LocalStorageService } from '../../core/local-storage/local-storage.service';
import { Injectable } from '@angular/core';


export enum TokenType {
  access = 'access_token',
  refresh = 'refresh_token',
  id = 'id_token'
}
